export function isDisabled(letters) {
  return letters.some(letter => !letter.task_id && !letter.document_node_id)
}
